var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.95 8C13.95 11.2861 11.2861 13.95 8 13.95C4.71391 13.95 2.05 11.2861 2.05 8C2.05 4.71391 4.71391 2.05 8 2.05C11.2861 2.05 13.95 4.71391 13.95 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.07232 4.26666C8.26149 4.26666 8.41484 4.42001 8.41484 4.60918L8.41484 7.6577H11.4631C11.6523 7.6577 11.8057 7.81106 11.8057 8.00022C11.8057 8.18939 11.6523 8.34274 11.4631 8.34274L8.41484 8.34274V11.3908C8.41484 11.58 8.26149 11.7333 8.07232 11.7333C7.88315 11.7333 7.7298 11.58 7.7298 11.3908V8.34274L4.68151 8.34274C4.49234 8.34274 4.33899 8.18939 4.33899 8.00022C4.33899 7.81106 4.49234 7.6577 4.68151 7.6577H7.7298V4.60918C7.7298 4.42001 7.88315 4.26666 8.07232 4.26666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/PlusBlack.56a48dc3d7cfb18777af607e321ca691.svg";
export { ForwardRef as ReactComponent };